import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { AuthStateService } from './auth-state-service';
import { TokenService } from '../services/tokenservice/token.service';
import { environment } from 'src/environments/environment';
import { LoadingService } from '../services/loadingservice/loading.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGovService {
  private readonly apiUrl = environment.urlBaseGOV;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authStateService: AuthStateService,
    private tokenService: TokenService,
    private loadingService: LoadingService
  ) { }

  startGovBrLogin(): void {
    this.authStateService.setAuthMethod('gov');
    window.location.href = environment.redirectUrlGOVBR;
  }

  obtainGovBrToken(code: string, state: string): Observable<any> {
    const body = { code, state };
    this.authStateService.CurrentAuthorizationState.next('GOV_INICIADO');

    this.loadingService.show();

    return this.http.post<any>(this.apiUrl, body).pipe(
      tap((x) => console.log('govbr obtainToken', x)),
      catchError((err) => {
        console.error('govbr obtainToken failed:', err);
        return throwError(err);
      }),
      finalize(() => {
        this.loadingService.hide();
        this.authStateService.CurrentAuthorizationState.next('GOV_FINALIZADO');
      })
    );
  }

  handleCallback(queryParams: any): Observable<any> {
    const code = queryParams['code'];
    const state = queryParams['state'];

    if (code && state) {
      return this.obtainGovBrToken(code, state).pipe(
        tap((response) => {
          if (response.access_token) {
            this.tokenService.setToken(response.access_token);
            this.router.navigate(['/auth']);
          }
        }),
        catchError((err) => {
          console.error('Erro ao obter o token do GovBR:', err);
          return throwError(err);
        })
      );
    } else {
      throw new Error('Code ou State não encontrados nos parâmetros de consulta');
    }
  }
}
